export default {
  translation: {
    nav: {
      home: '首页',
      trips: '旅行',
      aboutUs: '关于我们',
      alerts: '通知',
      wishlist: '收藏',
      language: '语言',
      profile: '个人资料',
      settings: '设置',
      signIn: '登录',
      signUp: '注册'
    },
    hero: {
      title: '探索乌干达',
      subtitle: '及更多',
      description: '与专业的当地导游一起探索非洲明珠。难忘的体验在乌干达令人惊叹的自然景观和充满活力的文化中等待着您。',
      searchPlaceholder: '您想去哪里？',
      categories: {
        all: '全部',
        wildlife: '野生动物',
        safari: '野生动物园',
        cultural: '文化',
        adventure: '冒险',
        birding: '观鸟'
      }
    },
    common: {
      from: '起价',
      reviews: '评论',
      viewMore: '查看更多',
      book: '预订',
      seeAll: '查看全部',
      loading: '加载中...'
    }
  }
};